import { useNotification } from 'admin';
import {
  getApiSamplesV1SamplesListRetrieveQueryKey,
  SampleType,
  useApiSamplesV1SamplesCreate,
  useQueryClient,
} from 'api';
import { useSiteMaterial } from 'features';
import { Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ActionRow, Button, CardsListSkeleton, Grid, Menu, MenuItem, Page, Section } from 'ui';
import { ArrowDropDown } from 'ui/icons';

import { SampleList } from '../../components/SampleList/SampleList';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const Samples = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { open } = useNotification();
  const { data: siteMaterial } = useSiteMaterial();
  const { mutate: createSample } = useApiSamplesV1SamplesCreate({
    mutation: {
      onError: (error) =>
        open?.({
          message: `Error creating sample: ${error}`,
          type: 'error',
        }),
      onSuccess: ({ id }) => {
        open?.({
          message: 'Sample created',
          type: 'success',
        });
        queryClient.invalidateQueries({ queryKey: getApiSamplesV1SamplesListRetrieveQueryKey(siteMaterial.public_id) });
        navigate(`${id}/edit`);
      },
    },
  });
  const handleCreate = (type: SampleType) => createSample({ data: { site_material_id: siteMaterial.id, type } });

  const options = [
    { label: 'Manual Sample', onClick: () => handleCreate(SampleType.MG) },
    { label: 'AI Sample', onClick: () => handleCreate(SampleType.AG) },
    { disabled: true, label: 'Lab Report', onClick: () => null },
  ];
  return (
    <Page>
      <Page.Title title="Manage Samples" />
      <Page.Divider />
      <Grid container>
        <Grid item xs={12} md={4}>
          <Section title="Site Details">
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid item xs={12} md={8}>
          <Section
            title="Samples"
            action={
              <ActionRow>
                <Button size="large" fullWidth variant="secondary" component={Link} to="edit">
                  Edit
                </Button>

                <Menu
                  button={
                    <Button fullWidth size="large" endIcon={<ArrowDropDown />}>
                      Create
                    </Button>
                  }
                >
                  {options.map((option) => (
                    <MenuItem key={option.label} onClick={option.onClick} disabled={option.disabled}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Menu>
              </ActionRow>
            }
          >
            <Suspense fallback={<CardsListSkeleton />}>
              <SampleList siteMaterialId={siteMaterial.public_id} />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
